import React from 'react';
import Parent from './parent';
import { withTranslation } from 'react-i18next';
import {BllinkLogger} from './utils/bllink_loggers';
import './buildingTitle.css'


export class BuildingTitle extends Parent {

    constructor(props) {
        super(props);

        this.state = {
            address: null,
            titleData: {welcomeKey: 'welcome', translationKey: 'empty'},
        }
    }

    async componentDidMount() {
        if (this.props.buildingID && !this.state.building) {
            let building = await this.fetchBuildingData(this.props.buildingID);
            await this.setState({
                address: building?.address,
            })
        }
    }

    render() {

        const {t} = this.props;
        let address = this.props.address || this.state.address;
        const titleData = this.buildingTitle(address, this.props.apartmentNumber, this.props.type || 'paymentTo');
        BllinkLogger.info(`building title `, this.props, titleData);

        if (this.props.sidebarPage) {
            return (
                <h1 className='page-title margin-bottom'>
                    {t('payments.' + titleData.welcomeKey)}
                    <span className='address'>{t('payments.' + titleData.translationKey, titleData)}</span>
                </h1>
            )
        }

        return (
            <div id="payment-heading">
                <h2 className="text-center">
                    {t('payments.' + titleData.welcomeKey)}
                    <span>{t('payments.' + titleData.translationKey, titleData)}</span>
                </h2>
            </div>
        )
    }
}



export default withTranslation()(BuildingTitle);
